var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',_vm._b({ref:"upload",attrs:{"drag":_vm.isDraggable,"show-file-list":_vm.hasFileList,"auto-upload":_vm.isAutoUpload,"limit":_vm.uploadFileMax}},'el-upload',_vm.trimAttrs(_vm.$attrs),false),[_c('template',{slot:"trigger"},[_vm._t("trigger")],2),_c('template',{slot:"tip"},[_vm._t("tip")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }